import { apiClient } from "@/lib/apiClient";

export interface DashboardStats {
  invites_sent: number;
  opened_count: number;
  open_rate: number;
  redeemed_count: number;
  redemption_rate: number;
  /** True when redemption_rate was clamped to 100 because redeemed exceeded its denominator. */
  redemption_rate_capped: boolean;
  /** The denominator redemption_rate was computed against — needed to explain the cap. */
  redemption_denominator: number;
  note_count: number;
  charity_donations_count: number;
  charity_impact_count: number;
  charity_rate: number;
  /** Every campaign Recent Campaigns draws from; /dashboard/campaigns returns only the top four. */
  campaign_count: number;
}

export async function fetchDashboardStats(): Promise<DashboardStats> {
  const { data } = await apiClient.get<DashboardStats>("/dashboard/stats");
  return data;
}

export interface ThankYouNote {
  id: number;
  sender: string;
  message: string;
  for: string;
  /** When the note was left, ISO-8601 UTC (`coalesce(thanks_at, updatedAt)` on the API). */
  submitted: string;
}

export async function fetchDashboardNotes(): Promise<ThankYouNote[]> {
  const { data } = await apiClient.get<ThankYouNote[]>("/dashboard/notes");
  return data;
}

export interface UpcomingDate {
  title: string;
  date: string;
}

export async function fetchDashboardDates(): Promise<UpcomingDate[]> {
  const { data } = await apiClient.get<UpcomingDate[]>("/dashboard/dates");
  return data;
}

export interface DashboardCampaign {
  id: number;
  title: string;
  state: string;
  startDate: string;
  endDate: string;
}

export async function fetchDashboardCampaigns(): Promise<DashboardCampaign[]> {
  const { data } = await apiClient.get<DashboardCampaign[]>("/dashboard/campaigns");
  return data;
}

export async function fetchDashboardTopGifts() {
  const { data } =
    await apiClient.get<import("@/interfaces/product").Product[]>("/dashboard/top-gifts");
  return data;
}
